import { render, staticRenderFns } from "./TemplateItemPage.vue?vue&type=template&id=6faa7bb2&scoped=true&"
import script from "./TemplateItemPage.vue?vue&type=script&lang=js&"
export * from "./TemplateItemPage.vue?vue&type=script&lang=js&"
import style0 from "./TemplateItemPage.vue?vue&type=style&index=0&id=6faa7bb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faa7bb2",
  null
  
)

export default component.exports